import React from 'react'
import * as PropTypes from 'prop-types'
import classNames from 'classnames'
import { Text } from '~src/new/shared/ui/Text/Text'
import cls from './pill-tooltip.module.scss'

/**
 * Тёмный тултип по hover (чистый CSS, без DOM-замеров); `disableMobile` — чтобы не мешать тач переходам.
 * @param {{children: React.ReactNode, text: string, disableMobile?: boolean, className?: string}} props
 * @returns {JSX.Element}
 */
export const PillTooltip = ({ children, text, disableMobile, className }) => (
  <div className={classNames(cls.wrap, className)}>
    {children}
    <span className={classNames(cls.pill, { [cls.disableMobile]: disableMobile })}>
      <Text variant="body-xsmall" className={cls.text}>
        {text}
      </Text>
    </span>
  </div>
)

PillTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  disableMobile: PropTypes.bool,
  className: PropTypes.string,
}
